import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="container py-5 text-center">
      <h1 className="">404</h1>
      <p className="fs-150 fw-500"> Sorry, the page you are looking for does not exist. <i className="bi bi-emoji-astonished text-warning"></i></p>
      <Link className="btn btn-lg btn-primary" to="/">
        <div className="">Back to Home</div>
      </Link>
    </div>
  );
}